import React from 'react';
import { ModalScrollContent } from 'snacks-design-system';

interface componentProps {
  children: React.ReactNode;
}

const PIEModalScrollContent = (props: componentProps) => {
  return <ModalScrollContent {...props} />;
};

export default PIEModalScrollContent;
